/**
 * Flèches de sens le long d'un itinéraire : une tous les [spacingM] mètres (au plus [max]),
 * avec le cap à suivre (0 = nord, sens horaire). Pure : testée sans carte.
 */
const R = 6371000;
const rad = d => d * Math.PI / 180;

export function distanceM(a, b) {
    const dLat = rad(b[0] - a[0]);
    const dLon = rad(b[1] - a[1]);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(h));
}

export function bearingDeg(a, b) {
    const y = Math.sin(rad(b[1] - a[1])) * Math.cos(rad(b[0]));
    const x = Math.cos(rad(a[0])) * Math.sin(rad(b[0])) - Math.sin(rad(a[0])) * Math.cos(rad(b[0])) * Math.cos(rad(b[1] - a[1]));
    return (Math.atan2(y, x) * 180 / Math.PI + 360) % 360;
}

/** [[lat, lng], …] → [{ lat, lng, bearing }] ; espacement agrandi pour ne pas dépasser [max]. */
export function arrowsAlong(latLngs, { spacingM = 150, max = 60 } = {}) {
    if (!Array.isArray(latLngs) || latLngs.length < 2) return [];
    let total = 0;
    for (let i = 1; i < latLngs.length; i++) total += distanceM(latLngs[i - 1], latLngs[i]);
    if (total <= 0) return [];
    const step = Math.max(spacingM, total / max);
    const arrows = [];
    let next = step / 2;
    let walked = 0;
    for (let i = 1; i < latLngs.length && arrows.length < max; i++) {
        const a = latLngs[i - 1];
        const b = latLngs[i];
        const seg = distanceM(a, b);
        while (seg > 0 && next <= walked + seg && arrows.length < max) {
            const t = (next - walked) / seg;
            arrows.push({ lat: a[0] + (b[0] - a[0]) * t, lng: a[1] + (b[1] - a[1]) * t, bearing: bearingDeg(a, b) });
            next += step;
        }
        walked += seg;
    }
    return arrows;
}
